export enum BulkOperationSubTypeEnum {
  SUBMIT = 'submit',
  APPROVE = 'approve',
  REJECT = 'reject',
  OWNERS = 'owners',
  OPERATORS = 'operators',
  FREQUENCY_MANAGERS = 'managers',
}